export default __webpack_public_path__ + "static/media/smile_black_lady.16b3ad1f.jpg";